import React from 'react';

export const AddImageIcon = () => {
    return (
        <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M63.3333 16.6667V63.3333H16.6667V16.6667H63.3333ZM63.3333 10H16.6667C13 10 10 13 10 16.6667V63.3333C10 67 13 70 16.6667 70H63.3333C67 70 70 67 70 63.3333V16.6667C70 13 67 10 63.3333 10ZM47.1333 39.5333L37.1333 52.4333L30 43.8L20 56.6667H60L47.1333 39.5333Z" fill="black" fillOpacity="0.26"/>
        </svg>
    );
};
